var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.31,
    height: 36.31,
    "data-name": "Group 777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.156 0A18.155 18.155 0 1 0 36.31 18.156 18.157 18.157 0 0 0 18.156 0m-4.1 26.07H10.54v-11.3h3.516Zm-1.758-12.838a2.036 2.036 0 1 1 2.036-2.038 2.037 2.037 0 0 1-2.034 2.039Zm14.91 12.838h-3.509v-5.492c0-1.311-.025-3-1.824-3-1.828 0-2.107 1.428-2.107 2.9v5.589h-3.509v-11.3h3.367v1.545h.046a3.7 3.7 0 0 1 3.325-1.825c3.555 0 4.211 2.338 4.211 5.38Z",
    "data-name": "Path 559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedinWhite.831d26f731f0e89842694ea6e82223c1.svg";
export { ForwardRef as ReactComponent };